import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import ContentAccordion from 'libraries/ContentAccordion';
import Button from '@mui/material/Button';
import { format } from 'date-fns';
import TruncateWithTooltip from 'components/tooltips/TruncateWithTooltip';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import GeneralEvents from 'events/GeneralEvents';
import { SCORE_TYPE_AI } from 'helper/constants';
import styles from './styles';
import ReapplyCardDialog from './ReapplyCard';

const CompletionsHistory = observer(({ completionsHistory, classes, commonProps, fullName }) => {
    const [reapplyDialogOpened, setReapplyDialogOpened] = useState(false);
    const [selectedHistoryItem, setSelectedHistoryItem] = useState(null);

    const isSmallScreen = useMediaQuery('(max-width: 1200px)');

    const onViewResults = (item) => {
        setSelectedHistoryItem(item);
        setReapplyDialogOpened(true);
        const { score, scoreType } = item;
        const { user: { candidateUUID }, audition: { uuid, name } } = commonProps;
        let eventData = {
            candidateUUID,
            ttUUID: uuid,
            ttName: name,
            scoreType
        };
        if (score) {
            eventData = {
                ...eventData,
                score: score.score,
                scoreIsAI: score.type === SCORE_TYPE_AI
            };
        }
        GeneralEvents.CANDIDATE_REAPPLIED_VIEWED(eventData);
    };

    return (
        <>
            <ContentAccordion
                className={classes.accordion}
                header={(
                    <Typography className="u-mrg--bx2">
                Assessment Completion History
                    </Typography>
                )}
                content={(
                    <>
                        {completionsHistory.map((historyItem, idx) => {
                            const date = historyItem.completedAt
                                ? format(new Date(historyItem.completedAt), 'd MMMM, yyyy')
                                : <span>Incomplete</span>;
                            return (
                                <div className={classes.historyRow} key={idx}>
                                    <span className={classes.nameColumn}>
                                        <TruncateWithTooltip width={isSmallScreen ? 200 : 400} text={historyItem.auditionName} />
                                    </span>
                                    <span className={classes.timeColumn}>{date}</span>
                                    <span className={classes.buttonColumn}>
                                        <Button
                                            variant="text"
                                            onClick={() => onViewResults(historyItem)}
                                        >
                                        View results
                                        </Button>
                                    </span>
                                </div>
                            );
                        })}
                    </>
                )}
            />
            <ReapplyCardDialog
                open={reapplyDialogOpened}
                historyItem={selectedHistoryItem}
                onClose={() => setReapplyDialogOpened(false)}
                commonProps={commonProps}
                classes={classes}
                fullName={fullName}
            />
        </>
    );
});

export default withStyles(styles)(withRouter(CompletionsHistory));
